import { UploadConfig } from './upload.abstract.config';

export const uploadConfig: UploadConfig = {
  privileges: {
    candidates: {
      edit: 'web:candiadtes-edit',
    },
  },
};
